export const findSalePrice = ( product, sales ) => {

	if ( product.includeInSale && sales.length ) {
		if( sales[0].discount === "SetPrice" ) {
			product.salePrice = sales[0].amount
		} else if ( sales[0].discount === "Percentage"){
			product.salePrice = formatNumber( product.price * ( 1 - sales[0].amount/100 ) )
		}
	} else if ( product.includeInSale && product.sale ){
		if( product.sale.discount === "SetPrice" ) {
			product.salePrice = product.sale.amount
		} else if ( product.sale.discount === "Percentage" ){
			product.salePrice = formatNumber( product.price * ( 1 - product.sale.amount/100 ) )
		}
	}

	return product
}

export const formatNumber = ( priceWithDecimals ) => {

	if ( !priceWithDecimals ) {
		return 0;
	}
	
	return Math.round( priceWithDecimals * 100 ) / 100;
}